import { render } from "./AppUploader.vue?vue&type=template&id=0db357dd&ts=true"
import script from "./AppUploader.vue?vue&type=script&lang=ts"
export * from "./AppUploader.vue?vue&type=script&lang=ts"

import "./AppUploader.vue?vue&type=style&index=0&id=0db357dd&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__